<ng-container *ngIf="!isLoading else loading">
	<div class="card-title">
		<span translate>delivery-tracking.delivery-follow-up</span>
	</div>
	<div class="delivery-block">
		<button type="button" class="delivery-line"
				*ngIf="{ disabled: inLandTransit.qty === 0 } as inLandTransitRipple"
				[class.copo-clickable]="!inLandTransitRipple.disabled"
				[matRippleDisabled]="inLandTransitRipple.disabled"
				(click)="viewDetails(inLandTransit)" mat-ripple>
			<mat-icon class="mat-icon delivery-line-icon" role="img" svgIcon="in_transit"></mat-icon>
			<span class="delivery-line-tonnage">{{(inLandTransit.qty ? inLandTransit.qty : 0) | copoNumber: 'weight-aggregate':'t'}}</span>
			<span class="delivery-line-step" translate>delivery-tracking.in-land-transit</span>
			<mat-icon class="delivery-line-chevron" [class.visibility-hidden]="inLandTransit.qty === 0" color="accent" svgIcon="md:chevron_right"></mat-icon>
		</button>

		<button type="button" class="delivery-line"
				*ngIf="{ disabled: atReshipper.qty === 0 } as atReshipperRipple"
				[class.copo-clickable]="!atReshipperRipple.disabled"
				[matRippleDisabled]="atReshipperRipple.disabled"
				(click)="viewDetails(atReshipper)" mat-ripple>
			<mat-icon class="mat-icon delivery-line-icon" role="img" svgIcon="at_reshipper"></mat-icon>
			<span class="delivery-line-tonnage">{{(atReshipper.qty ? atReshipper.qty : 0) | copoNumber: 'weight-aggregate':'t'}}</span>
			<span class="delivery-line-step" translate>order-card.batches-at-reshipper</span>
			<mat-icon class="delivery-line-chevron" [class.visibility-hidden]="atReshipper.qty === 0" color="accent" svgIcon="md:chevron_right"></mat-icon>
		</button>

		<button type="button" class="delivery-line"
				*ngIf="{ disabled: onVessel.qty === 0 } as onVesselRipple"
				[class.copo-clickable]="!onVesselRipple.disabled"
				[matRippleDisabled]="onVesselRipple.disabled"
				(click)="viewDetails(onVessel)" mat-ripple>
			<mat-icon class="mat-icon delivery-line-icon" role="img" svgIcon="on_vessel"></mat-icon>
			<span class="delivery-line-tonnage">{{(onVessel.qty ? onVessel.qty : 0) | copoNumber: 'weight-aggregate':'t'}}</span>
			<span class="delivery-line-step" translate>order-card.batches-on-vessel</span>
			<mat-icon class="delivery-line-chevron" [class.visibility-hidden]="onVessel.qty === 0" color="accent" svgIcon="md:chevron_right"></mat-icon>
		</button>

		<button type="button" class="delivery-line"
				*ngIf="{ disabled: atOverseasStock.qty === 0 } as atOverseasStockRipple"
				[class.copo-clickable]="!atOverseasStockRipple.disabled"
				[matRippleDisabled]="atOverseasStockRipple.disabled"
				(click)="viewDetails(atOverseasStock)" mat-ripple>
			<mat-icon class="mat-icon delivery-line-icon" role="img" svgIcon="overseas_stock"></mat-icon>
			<span class="delivery-line-tonnage">{{(atOverseasStock.qty ? atOverseasStock.qty : 0) | copoNumber: 'weight-aggregate':'t'}}</span>
			<span class="delivery-line-step" translate>delivery-tracking.at-overseas-stock</span>
			<mat-icon class="delivery-line-chevron" [class.visibility-hidden]="atOverseasStock.qty === 0" color="accent" svgIcon="md:chevron_right"></mat-icon>
		</button>

		<button type="button" class="delivery-line"
				*ngIf="{ disabled: inOverseasTransit.qty === 0 } as inOverseasTransitRipple"
				[class.copo-clickable]="!inOverseasTransitRipple.disabled"
				[matRippleDisabled]="inOverseasTransitRipple.disabled"
				(click)="viewDetails(inOverseasTransit)" mat-ripple>
			<mat-icon class="mat-icon delivery-line-icon" role="img" svgIcon="on_vessel"></mat-icon>
			<span class="delivery-line-tonnage">{{(inOverseasTransit.qty ? inOverseasTransit.qty : 0) | copoNumber: 'weight-aggregate':'t'}}</span>
			<span class="delivery-line-step" translate>delivery-tracking.in-overseas-transit</span>
			<mat-icon class="delivery-line-chevron" [class.visibility-hidden]="inOverseasTransit.qty === 0" color="accent" svgIcon="md:chevron_right"></mat-icon>
		</button>

		<button type="button" class="delivery-line"
				*ngIf="{ disabled: inTransitToCustomer.qty === 0 } as inTransitToCustomerRipple"
				[class.copo-clickable]="!inTransitToCustomerRipple.disabled"
				[matRippleDisabled]="inTransitToCustomerRipple.disabled"
				(click)="viewDetails(inTransitToCustomer)" mat-ripple>
			<mat-icon class="mat-icon delivery-line-icon" role="img" svgIcon="in_transit"></mat-icon>
			<span class="delivery-line-tonnage">{{(inTransitToCustomer.qty ? inTransitToCustomer.qty : 0) | copoNumber: 'weight-aggregate':'t'}}</span>
			<span class="delivery-line-step" translate>delivery-tracking.in-transit-to-customer</span>
			<mat-icon class="delivery-line-chevron" [class.visibility-hidden]="inTransitToCustomer.qty === 0" color="accent" svgIcon="md:chevron_right"></mat-icon>
		</button>

		<button type="button" class="delivery-line"
				*ngIf="{ disabled: atConsignment.qty === 0 } as atConsignmentRipple"
				[class.copo-clickable]="!atConsignmentRipple.disabled"
				[matRippleDisabled]="atConsignmentRipple.disabled"
				(click)="viewDetails(atConsignment)" mat-ripple>
			<mat-icon class="mat-icon delivery-line-icon" role="img" svgIcon="at_consignment"></mat-icon>
			<span class="delivery-line-tonnage">{{(atConsignment.qty ? atConsignment.qty : 0) | copoNumber: 'weight-aggregate':'t'}}</span>
			<span class="delivery-line-step" translate>filter.atConsignment</span>
			<mat-icon class="delivery-line-chevron" [class.visibility-hidden]="atConsignment.qty === 0" color="accent" svgIcon="md:chevron_right"></mat-icon>
		</button>
	</div>
	<div class="card-block-footer mobile-hide">
		<button type="button" mat-button color="primary" (click)="viewDetails()">
			<span translate>order-tracking.card.delivery-date.view-details</span>
			<mat-icon iconPositionEnd color="accent" svgIcon="md:chevron_right"></mat-icon>
		</button>
	</div>
</ng-container>
<ng-template #loading>
	<copo-loading-spinner></copo-loading-spinner>
</ng-template>
